<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" :class="{ active: currentTab === 0 }">
            <a href="#tab-0" @click.prevent="resetValid" class="nav-link active show" role="tab" data-toggle="tab"
              >權限設定</a
            >
          </li>
          <li class="nav-item" :class="{ active: currentTab === 1 }">
            <a href="#tab-1" @click.prevent="resetValid" class="nav-link" role="tab" data-toggle="tab">編輯檢視</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <div id="tab-0" class="tab-pane active show" role="tabpanel">
          <cust-data-view-permission-add />
        </div>
        <div id="tab-1" class="tab-pane" role="tabpanel">
          <cust-data-view-permission-edit />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { commonMixin } from '@/mixins/common';
import CustDataViewPermissionAdd from './CustDataViewPermissionAdd';
import CustDataViewPermissionEdit from './CustDataViewPermissionEdit';

export default {
  name: 'CustDataViewPermission',
  data() {
    return {};
  },
  mixins: [commonMixin],
  components: {
    CustDataViewPermissionAdd,
    CustDataViewPermissionEdit
  },
  methods: {
    resetValid() {
      this.$validator.reset();
    }
  }
};
</script>
<style lang="scss" scoped></style>
